import { render } from "./FactoryManage.vue?vue&type=template&id=ac3d398a"
import script from "./FactoryManage.vue?vue&type=script&lang=ts"
export * from "./FactoryManage.vue?vue&type=script&lang=ts"
script.render = render

export default script